export default __webpack_public_path__ + "locales/ru/Ldap.json?hash=339e6121122b516ec6ea05164cf33c30";